<template>
    <div class="step">
        <div class="step-number">{{ number }}</div>
        <div class="step-content">
            <h3 class="step-title">{{ title }}</h3>
            <p class="step-gain">
                <i class="bi bi-arrow-right-circle-fill"></i>
                <span>{{ gain }}</span>
            </p>
            <hr class="divider" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "StepItem",
        props: {
            number: {
                type: String,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
            gain: {
                type: String,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .step {
        display: flex;
        gap: 1rem;
        align-items: flex-start;
        margin-bottom: 2rem;

        .step-number {
            font-size: 3rem;
            font-weight: bold;
            color: #850A56;
        }

        .step-content {
            flex: 1;

            .step-title {
                text-align: left !important;
            }

        }


        .step-gain {
            i {
                color: #850A56;
                font-size: 1.5rem;
                margin-right: 0.5rem;
            }
        }

        .divider {
            border: none;
            border-top: 2px solid #850A56;
            margin: 2rem 0;
        }

    }
</style>